export default __webpack_public_path__ + "static/media/bbaUSDC.f5be49dd.png";